import React from 'react';
import { motion } from 'framer-motion';
interface LoadingOverlayProps {
  message: string;
  subMessage?: string;
}
export function LoadingOverlay({
  message,
  subMessage
}: LoadingOverlayProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="absolute inset-0 z-50 bg-white/95 backdrop-blur-sm flex flex-col items-center justify-center px-8" data-id="element-1863">
      {/* Single AI-style orbiting ring + logo */}
      <div className="relative mb-10 flex items-center justify-center" style={{
      width: 120,
      height: 120
    }} data-id="element-1864">
        {/* Rotating gradient ring */}
        <motion.div animate={{
        rotate: 360
      }} transition={{
        repeat: Infinity,
        duration: 2.5,
        ease: 'linear'
      }} className="absolute inset-0" data-id="element-1865">
          <svg viewBox="0 0 120 120" className="w-full h-full" data-id="element-1866">
            <defs data-id="element-1867">
              <linearGradient id="ai-gradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-1868">
                <stop offset="0%" stopColor="#facc15" stopOpacity="0" data-id="element-1869" />
                <stop offset="40%" stopColor="#facc15" stopOpacity="0.1" data-id="element-1870" />
                <stop offset="70%" stopColor="#facc15" stopOpacity="0.5" data-id="element-1871" />
                <stop offset="100%" stopColor="#facc15" stopOpacity="1" data-id="element-1872" />
              </linearGradient>
            </defs>
            <circle cx="60" cy="60" r="54" fill="none" stroke="url(#ai-gradient)" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="240 100" data-id="element-1873" />
          </svg>
        </motion.div>

        {/* Subtle static track ring */}
        <div className="absolute inset-0" data-id="element-1874">
          <svg viewBox="0 0 120 120" className="w-full h-full" data-id="element-1875">
            <circle cx="60" cy="60" r="54" fill="none" stroke="rgba(250,204,21,0.12)" strokeWidth="2.5" data-id="element-1876" />
          </svg>
        </div>

        {/* Logo */}
        <motion.img src="https://cdn.magicpatterns.com/uploads/axLnsnrKgnPpwhXfLHqzvK/image.png" alt="BiltOn" className="h-9 w-auto relative z-10" initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15,
        duration: 0.4,
        ease: 'easeOut'
      }} data-id="element-1877" />
      </div>

      {/* Message */}
      <motion.p initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.4
    }} className="text-gray-900 font-semibold text-base text-center mb-1" data-id="element-1878">
        {message}
      </motion.p>
      {subMessage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.4
    }} className="text-center space-y-1" data-id="element-1879">
          {subMessage.split('\n').map((line, i) => <p key={i} className={`text-xs ${i === 0 ? 'text-gray-400' : 'text-yellow-600 font-medium mt-2'}`} data-id="element-1880">
              {line}
            </p>)}
        </motion.div>}
    </motion.div>;
}